export default "__VITE_ASSET__43pjv6QM__"